import AsyncStorage from "@react-native-async-storage/async-storage";
import cuid from "cuid";
import React, { useEffect } from "react";
import * as Sentry from "@sentry/react-native";
const storesprint_tracking_device_id_key = "storesprint_tracking_device_id";
export function getDeviceId() {
  return AsyncStorage.getItem(
    storesprint_tracking_device_id_key,
    (err, res) => {
      if (err) {
        Sentry.captureException(err);
        return cuid();
      }
      if (res) {
        return res;
      } else {
        const id = cuid();
        return AsyncStorage.setItem(storesprint_tracking_device_id_key, id)
          .catch((e) => {
            Sentry.captureException(e);
            return id;
          })
          .then(() => {
            return id;
          });
      }
    }
  ).then((id) => {
    if (!id) {
      return cuid();
    }
    return id;
  });
}

export function useGetDeviceId() {
  const [deviceId, setDeviceId] = React.useState<string | null>(null);
  useEffect(() => {
    getDeviceId().then((id) => {
      setDeviceId(id);
    });
  }, []);

  return deviceId;
}
